import {FC, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import {subscribeGlobalLoading} from './globalLoadingBus'
import './FullScreenAppLoader.css'

/**
 * Full-viewport branded loader for the whole admin SPA.
 * Icon sits inside a round badge; spinner orbits outside so nothing clips.
 */
const FullScreenAppLoader: FC = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => subscribeGlobalLoading(setVisible), [])

  if (!visible) return null

  return (
    <div className='shrido-fullscreen-loader' role='status' aria-live='polite' aria-busy='true'>
      <div className='shrido-fullscreen-loader__glow' aria-hidden='true' />
      <div className='shrido-fullscreen-loader__panel'>
        <div className='shrido-fullscreen-loader__orbit'>
          <span className='shrido-fullscreen-loader__spinner' aria-hidden='true' />
          <span className='shrido-fullscreen-loader__badge'>
            <img
              src={toAbsoluteUrl('/media/logo_without_name.svg')}
              alt=''
              className='shrido-fullscreen-loader__mark'
            />
          </span>
        </div>

        <img
          src={toAbsoluteUrl('/media/logo.svg')}
          alt='Shrido'
          className='shrido-fullscreen-loader__wordmark'
        />

        <div className='shrido-fullscreen-loader__label'>
          Loading
          <span className='shrido-fullscreen-loader__dots' aria-hidden='true'>
            <i />
            <i />
            <i />
          </span>
        </div>
      </div>
    </div>
  )
}

export default FullScreenAppLoader
